import { useTranslation } from 'react-i18next'

import { useFetchShopProducts } from '@entities/Product'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'

import { URL_CATEGORY_NEW_PRODUCTS } from '@shared/contants'

export default function ProductCarouselNew () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  const { products, loading } = useFetchShopProducts({
    shopId,
    page: 1,
    limit: 20,
    sort: {
      fieldName: 'new',
      direction: 1,
    },
  })

  return (
    <>
      {products && products.length > 0 && (
        <ProductCarousel
          link={URL_CATEGORY_NEW_PRODUCTS}
          title={tp('new')}
          products={products}
          loading={loading}
        />
      )}
    </>
  )
}